<template>
  <div class="sales-box mb-2">
    <div class="d-flex p-0 col-12">
      <div class="col-1 d-flex sales-info-wrapper p-0">
        <a href="#">
          <div @click.stop.prevent="goToUser" class="sale-ref-id pointer">{{ sale.full_name }}</div>
        </a>
      </div>
      <div class="flex-even d-flex">
        <div class="col-6 sale-info-numbers">
          {{ sale.total_jobs || 0 }}
        </div>
        <div class="col-6 sale-info-numbers">
          {{ sale.total_leads || 0 }}
        </div>
      </div>
      <div class="flex-even d-flex">
        <div class="col-6 sale-info-numbers">
          {{ sale.phone_jobs || 0 }}
        </div>
        <div class="col-6 sale-info-numbers">
          {{ sale.phone_leads || 0 }}
        </div>
      </div>
      <div class="flex-even d-flex">
        <div class="col-6 sale-info-numbers">
          {{ sale.website_jobs || 0 }}
        </div>
        <div class="col-6 sale-info-numbers">
          {{ sale.website_leads || 0 }}
        </div>
      </div>
      <div class="flex-even d-flex">
        <div class="col-6 sale-info-numbers">
          {{ sale.yelp_chat_jobs || 0 }}
        </div>
        <div class="col-6 sale-info-numbers">
          {{ sale.yelp_chat_leads || 0 }}
        </div>
      </div>
      <div class="flex-even d-flex">
        <div class="col-6 sale-info-numbers">
          {{ sale.no_availability_all || 0 }}
        </div>
        <div class="col-6 sale-info-numbers">
          {{ sale.no_availability_website || 0 }}
        </div>
      </div>
      <div class="col-1 d-flex">
        <div class="sale-info-numbers">
          {{ sale.mod_jobs || 0 }}
        </div>
      </div>
      <div class="col-2 d-flex">
        <div class="col-4 sale-info-numbers">
          {{ sale.conversion_total || 0 }}%
        </div>
        <div class="col-4 sale-info-numbers">
          {{ sale.conversion_phone || 0 }}%
        </div>
        <div class="col-4 sale-info-numbers">
          {{ sale.conversion_website || 0 }}%
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SalesTotalsBlock',
  props: {
    sale: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    goToUser() {
      window.open(this.$router.resolve(`/users/edit/${this.sale.id}`).href, '_blank');
    },
  },
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: none;
}
.sales-box {
  display: flex;
  justify-content: space-between;
  background: #ffffff;
  box-shadow: 0 2px 9px -4px rgba(15, 20, 54, 0.17), 0 7px 25px -3px rgba(50, 50, 93, 0.03);
  border-radius: 2px;
  height: 70px;
}
.sales-box > div:first-child > div:first-child {
  padding: 12px 0 0 12px !important;
}
.sales-info-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.sale-ref-id {
  font-weight: bold;
  font-size: 12px;
  color: #4c5669;
}
.sale-ref-id:hover {
  color: #2962ff;
}
.sale-info {
  font-size: 10px;
  color: #4c5669;
}
.sale-info-numbers {
  font-size: 12px;
  display: flex;
  align-items: center;
  color: #4c5669;
}
.sales-icon {
  color: #c0c6cc;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/sales/SalesTotalsBlock.vue